import { useMemo } from 'react';
import { Grid, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useZone, useZoneActions } from '../ZoneContext';
import RadioGroupField from '../common/RadioGroupField';

const Weekdays = () => {
    const { t } = useTranslation();
    const zone = useZone();
    const { updateField } = useZoneActions();
    const weekDaysData = zone.weekDays;

    const weekdays = useMemo(() => [
        { key: 'monday', label: t('settings.zones.fields.week_days.monday') },
        { key: 'tuesday', label: t('settings.zones.fields.week_days.tuesday') },
        { key: 'wednesday', label: t('settings.zones.fields.week_days.wednesday') },
        { key: 'thursday', label: t('settings.zones.fields.week_days.thursday') },
        { key: 'friday', label: t('settings.zones.fields.week_days.friday') },
        { key: 'saturday', label: t('settings.zones.fields.week_days.saturday') },
        { key: 'sunday', label: t('settings.zones.fields.week_days.sunday') }
    ], [t]);

    const zoneAppliesOptions = useMemo(() => [
        {
            value: 'hours_worked',
            label: t('settings.zones.fields.week_days.hours_worked')
        },
        {
            value: 'hours_to_day',
            label: t('settings.zones.fields.week_days.hours_applied')
        }
    ], [t]);

    return (
        <Grid container spacing={2}>
            {/* Checkboxes de días */}
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1.5 }}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">
                        {t('settings.zones.fields.week_days.title')}
                    </FormLabel>
                    <FormGroup aria-label="weekdays" row>
                        {weekdays.map(({ key, label }) => (
                            <FormControlLabel
                                key={key}
                                control={
                                    <Checkbox
                                        checked={weekDaysData[key]}
                                        onChange={(e) => updateField('weekDays', key, e.target.checked)}
                                        name={key}
                                    />
                                }
                                label={label}
                            />
                        ))}
                    </FormGroup>
                </FormControl>
            </Grid>

            {/* Zone Applies */}
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <RadioGroupField
                    label={t('settings.zones.fields.week_days.zone_applies_to')}
                    value={weekDaysData.zoneApplies}
                    onChange={(e) => updateField('weekDays', 'zoneApplies', e.target.value)}
                    options={zoneAppliesOptions}
                    name="zone-applies"
                />
            </Grid>
        </Grid>
    );
};

export default Weekdays;